export const AppBusinessStoreRedirectRoutes = {
    ROOT: "/george-business-app"
};


// WEBPACK FOOTER //
// ./src/components/appBusinessStoreRedirect/AppBusinessStoreRedirectRoutes.ts